import { getParams } from "../utils/helpers";
import envConfig from "../config/envConfig";

// Build headers lazily on each access so that a runtime locale/token change
// is picked up by callers that use this object as axios config.
export const buildHeaders = () => {
  const { locale, accessToken } = getParams();
  return {
    "Accept-Language": locale || "en",
    Accept: "application/json",
    Authorization: "Bearer " + accessToken,
    "Access-Control-Allow-Origin": "*",
  };
};

// Backwards-compatible `config` object — `headers` is a getter so each axios
// call reads the latest locale/token at request time instead of at module load.
export const config = {
  get headers() {
    return buildHeaders();
  },
};

export const APP_URL = envConfig.API_URL;
export const USER_API_URL = envConfig.API_URL;
